import {BaseModel} from '../baseModel';
import {Country} from '../res/country';
import {State} from '../res/state';
import {Attachment} from '../res/attachment';


export class LicenseInfo extends BaseModel<number> {
  licenseNumber: string;
  countryIssued: Country;
  stateIssued: State;
  effectiveDate: Date;
  expirationDate: Date;
  attachment: Attachment;
}
